import React, { useEffect } from 'react'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import StatisticCard from './StatisticCard'
import CompletionRate from './CompletionRate'
import LeaderBoard from './LeaderBoard'
import classes from './BusinessUserDashboard.module.css'
import Courses from './Courses'
import BlueBackground from '../../assets/images/blue-background.svg'
import OrangeBackground from '../../assets/images/orange-background.svg'
import PinkBackground from '../../assets/images/pink-background.svg'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import Footer from '../../components/Footer/Footer'
import { getBusinessUserStatistics } from './dashboardApi'
import { dashboardSelectors } from './dashboardSlice'
import Spinner from '../../components/loaders/Spinner'
import notification from '../../components/Notification/notification'

const BusinessDashboard = () => {
    const dispatch = useDispatch()
    const statistics = useSelector(dashboardSelectors.businessUserStatistics)
        .data
    const isFetchingStatistics = useSelector(dashboardSelectors.isFetching)
        .businessUserStatistics
    const statisticsErrorMessage = useSelector(dashboardSelectors.errorMessage)
        .businessUserStatistics
    const statisticsHasError = useSelector(dashboardSelectors.hasError)
        .businessUserStatistics

    useEffect(() => {
        dispatch(getBusinessUserStatistics())
    }, [])

    useEffect(() => {
        if (statisticsHasError) {
            notification.failure({
                title: 'Failed to load statistics',
                description: statisticsErrorMessage,
            })
        }
    }, [statisticsHasError])

    const renderTopHeader = () => {
        return (
            <div className={classNames(classes.container, classes.topHeader)}>
                <div>Overview</div>
            </div>
        )
    }

    const renderStatistics = () => {
        return (
            <div className={classNames(classes.container)}>
                <div>
                    <div
                        className={classNames(
                            'row gy-6',
                            classes.statisticCardContainer
                        )}
                    >
                        {isFetchingStatistics ? (
                            <Spinner />
                        ) : (
                            <>
                                <div className="col-12 col-md-6 col-lg-4">
                                    <StatisticCard
                                        name="Total Courses"
                                        value={statistics?.totalCourses}
                                        style={{
                                            backgroundImage: `url(${BlueBackground})`,
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-4">
                                    <StatisticCard
                                        name="Staff"
                                        value={statistics?.totalStaff}
                                        style={{
                                            backgroundImage: `url(${OrangeBackground})`,
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-4">
                                    <StatisticCard
                                        name="Time Spent"
                                        value={`${statistics?.totalTimeSpent?.toLocaleString()} Hours`}
                                        style={{
                                            backgroundImage: `url(${PinkBackground})`,
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    const renderMiddleSection = () => {
        return (
            <div className={classNames(classes.container)}>
                <div>
                    <div className={classNames(classes.middleSection, 'row')}>
                        <div className="col-12 col-lg-6">
                            <CompletionRate />
                        </div>
                        <div
                            className={classNames(
                                'col-12 col-lg-6',
                                classes.leaderboardContainer
                            )}
                        >
                            <LeaderBoard />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={classes.page}>
            <AuthenticatedHeader />
            {renderTopHeader()}
            {renderStatistics()}
            {renderMiddleSection()}
            <Courses />
            <Footer />
        </div>
    )
}

export default React.memo(BusinessDashboard)
